import React from 'react';
import PropTypes from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const SimpleBarChart = ({ data }) => (
  <ResponsiveContainer height={300} width="100%">
    <BarChart data={data} margin={{ top: 20, left: -10 }}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="reference_name" />
      <Tooltip />
      <Legend />

      <YAxis yAxisId="left" orientation="left" stroke="#00C49F" style={{ direction: "ltr", marginLeft: '5px' }} />
      <Bar yAxisId="left" dataKey="fully_implemented" fill="#00C49F" name="Fully Implemented" />
      <Bar yAxisId="left" dataKey="mostly_implemented" fill="#4CAF50" name="Mostly Implemented" />
      <Bar yAxisId="left" dataKey="averagely_implemented" fill="#8BC34A" name="Averagely Implemented" />
      <Bar yAxisId="left" dataKey="implemented" fill="#CDDC39" name="Implemented" />
      <Bar yAxisId="left" dataKey="partially_compliant" fill="#FF9800" name="Partially Compliant" />
      <Bar yAxisId="left" dataKey="non_compliant" fill="#F44336" name="Non Compliant" />
    </BarChart>
  </ResponsiveContainer>
);

SimpleBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    reference_name: PropTypes.string,
    fully_implemented: PropTypes.number,
    mostly_implemented: PropTypes.number,
    averagely_implemented: PropTypes.number,
    implemented: PropTypes.number,
    partially_compliant: PropTypes.number,
    non_compliant: PropTypes.number,
  })).isRequired,
};

export default SimpleBarChart;
